<template>
  <div class="contacts-page">
    <div class="max-width">
      <div class="subs">
        <router-link to="/" class="subs__links">Home</router-link>
        <span>Contacts</span>
      </div>

      <div class="contacts-page__grid">
        <div class="contacts-page__about">
          <div class="section__head">
            <h1 class="section__title">Contact Us <br>in&nbsp;One&nbsp;Click</h1>
            <div class="section__text">Whether you need help with licensing, billing, or technical issues—or want to explore pricing or share feedback—we’re here to assist you. Reach out anytime with just one click.</div>
          </div>
        </div>

        <div class="contacts-page__form fadeIn">
          <form class="sh-form form-contacts">
            <input type="hidden" name="TYPE_FORM" value="contact">
            <input type="hidden" name="Theme" value="None">
            <input type="hidden" name="PORTFOLIO" value="Creative Commerce">

            <div class="sh-form__grid">
              <div class="sh-form__field">
                <label>Name<span>*</span></label>
                <input
                    class="input-text input-name"
                    type="text"
                    name="Name"
                    placeholder="Your Name"
                    required
                />
              </div>
              <div class="sh-form__field">
                <label>E-mail<span>*</span></label>
                <input
                    class="input-text input-email"
                    type="email"
                    name="Email"
                    placeholder="Enter your e-mail"
                    required
                />
              </div>
              <div class="sh-form__field sh-form__field_full">
                <label>Message<span>*</span></label>
                <small>Please provide details and, if necessary.</small>
                <textarea
                    class="input-text input-message"
                    name="Message"
                    placeholder="Your Message"
                    required
                ></textarea>
              </div>
            </div>

            <div class="sh-form__checkboxes">
              <div class="sh-form-checkbox">
                <input type="checkbox" name="AGREEMENT" class="checkbox-terms" id="checkbox-terms">
                <label for="checkbox-terms">I agree to the <router-link to="/terms" target="_blank">Terms</router-link> & <router-link to="/privacy" target="_blank">Privacy Policy</router-link></label>
              </div>
              <div class="sh-form-checkbox">
                <input type="checkbox" name="SUBSCRIBE" id="checkbox-newsletter">
                <label for="checkbox-newsletter">I want to receive exclusive content from Creative&nbsp;Commerce: insider&nbsp;guides and personalized tips for my store.</label>
              </div>
            </div>

            <button class="sh-form__submit sh-form__submit_full" type="submit">
              <span class="button button_dark">
                Submit Request
                <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.00767 2.3999L13.6689 7.061M13.6689 7.061L9.08285 11.6471M13.6689 7.061L1.40002 7.061"
                        stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <div class="sh-form-loader"></div>
              </span>
            </button>

            <p class="sh-from-message"></p>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.contacts-page {
  &__grid {
    display: flex;
    justify-content: space-between;
    gap: 3rem;

    @include md {
      flex-direction: column;
      gap: 2.5rem;
      align-items: center;
    }
  }

  &__about {
    max-width: 550px;
    padding-top: 6.125rem;

    @include md {
      padding: 0;
      max-width: 480px;
      text-align: center;
    }

    .section__head {
      margin: 0;
    }

    .section__title {
      font-size: 4rem;
      max-width: 400px;

      @include md {
        font-size: 3rem;
      }

      @include xs {
        font-size: 2.5rem;
      }
    }

    .section__text {
      max-width: 100%;
    }
  }

  &__form {
    max-width: 478px;
    background: #fff;
    padding: 1.75rem;
    flex: none;
    width: 100%;
    border-radius: 12px;
  }
}
</style>

<script setup>
import { onMounted } from 'vue'
import JustValidate from 'just-validate'

import { useHead } from '@vueuse/head'

useHead({
  title: 'Contacts – Creative Commerce',
  meta: [
    { name: 'description', content: 'Get in touch with Creative Commerce Labs via our contact form. We assist with bug fixes, theme customizations, and questions regarding themes.' }
  ]
})

onMounted(() => {
  const form = document.querySelector('.form-contacts')

  if (form) {
    const validation = new JustValidate(form)

    validation
        .addField('.checkbox-terms', [
          {
            rule: 'required',
            value: true,
            errorMessage: 'Please select agrees'
          }
        ])
        .addField('.input-name', [
          {
            rule: 'minLength',
            value: 3
          },
          {
            rule: 'maxLength',
            value: 30
          },
          {
            rule: 'required',
            value: true,
            errorMessage: 'Please enter your first name'
          }
        ])
        .addField('.input-email', [
          {
            rule: 'required',
            value: true,
            errorMessage: 'Please enter your email'
          },
          {
            rule: 'email',
            value: true
          }
        ])
        .addField('.input-message', [
          {
            rule: 'required',
            value: true,
            errorMessage: 'Please enter your message'
          }
        ])
        .onSuccess((event) => {
          const formData = new FormData(event.target)
          const xhr = new XMLHttpRequest()

          form.classList.add('loading')

          const messageEl = document.querySelector('.sh-from-message');
          messageEl.classList.remove('sh-from-message_success', 'sh-from-message_error');
          messageEl.textContent = '';

          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                messageEl.textContent = 'Thank you for your submission! We will contact you shortly.'
                messageEl.classList.add('sh-from-message_success')
                event.target.reset()
              } else {
                messageEl.textContent = 'Something went wrong.'
                messageEl.classList.add('sh-from-message_error')
              }
              form.classList.remove('loading')
            }
          }

          xhr.open('POST', 'https://creativecommercelabs.com/zendesk/subscribe.php', true)
          xhr.send(formData)
        })
  }
})
</script>
